import React from "react";
import Popup from "react-popup";
import { useState } from "react";
import bsCustomFileInput from "bs-custom-file-input";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
function notifiPopup(titulo, mensaje) {
  Popup.create({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });
}

/*****************************
 * HANDLE ERROR TYPE OF FILE *
 *****************************/

function handleErrorTypeFile(element, event) {
  let typeFile = event.target.files[0]?.type;

  if (
    typeFile !== "application/pdf" &&
    typeFile !== "image/jpeg" &&
    typeFile !== "image/png"
  ) {
    element.current.value = "";
    element.current.dispatchEvent(new Event("change"));
    Popup.queue(notifiPopup("Error", "Adjuntar archivo .pdf, .jpg o .png"));
    return true;
  }
  return false;
}

/*****************************
 * HANDLE ERROR SIZE OF FILE *
 *****************************/

function handleErrorSize(element, event) {
  let sizeFile = event.target.files[0].size;

  if (sizeFile > 999999) {
    element.current.value = "";
    element.current.dispatchEvent(new Event("change"));
    Popup.queue(notifiPopup("Error", "El archivo debe ser menor a 1mb"));
    return true;
  }
  return false;
}

/***************
 * HANDLE FILE *
 ***************/

function openFile(element) {
  element.current.click();
}

function handleChangeFile(
  event,
  element,
  setDocumento,
  onChangedFile,
  rowItem
) {
  if (handleErrorTypeFile(element, event)) return;
  if (handleErrorSize(element, event)) return;

  setDocumento(event.target?.files[0]);
  onChangedFile(event.target?.files[0], rowItem);
}

function openPDF(fileBase64) {
  fetch(fileBase64)
    .then((res) => res.blob())
    .then((blob) => {
      window.open(URL.createObjectURL(blob));
    });
}

export default function InputFile({ onChangedFile, rowItem, listInputs }) {
  bsCustomFileInput.init();

  const documentoRef = React.createRef();
  // eslint-disable-next-line no-unused-vars
  const [documento, setDocumento] = useState(undefined);

  return (
    <div>
      <div className="row justify-content-md-center">
        <div className="col-md-8">
          <div className="form-group">
            <label className="add-document-label">{rowItem.titulo} *</label>
            <div key={rowItem.id} className="row-document">
              <div className="row">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span
                      className="btn btn-cu-primary"
                      id={"documento"}
                      onClick={() => openFile(documentoRef)}
                    >
                      Seleccionar
                    </span>
                  </div>
                  <div className="custom-file">
                    <input
                      type="file"
                      ref={documentoRef}
                      className="custom-file-input"
                      id={"documento"}
                      aria-describedby={"documento"}
                      accept=".pdf, .png, .jpg"
                      title={
                        rowItem.fileArchivo
                          ? `${rowItem.fileArchivo.name}`
                          : "Ningún archivo seleccionado"
                      }
                      onChange={(e) => {
                        handleChangeFile(
                          e,
                          documentoRef,
                          setDocumento,
                          onChangedFile,
                          rowItem
                        );
                      }}
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {rowItem.fileArchivo
                        ? `${rowItem.fileArchivo.name}`
                        : "Selecciona un nuevo archivo"}
                    </label>
                  </div>
                  <div className="col-md-3">
                    <div className="doc-flex">
                      {rowItem.extensionArchivo !== "pdf" && (
                        <button
                          className="btn btn-cu-secundary btn-document"
                          data-toggle="modal"
                          data-target={`#exampleModal${rowItem.id}`}
                          onClick={$(`#exampleModal${rowItem.id}`).appendTo('#modificarPaso1')}
                        >
                          <span><FontAwesomeIcon icon={faEye} /> Ver Rechazado</span>
                        </button>
                      )}
                      {rowItem.extensionArchivo === "pdf" && (
                        <button className="btn btn-cu-secundary btn-document" onClick={() => openPDF(rowItem.imageByteArray)}>
                          <span>
                          <FontAwesomeIcon icon={faEye} />  Ver Rechazado
                          </span>
                        </button>
                      )}
                    </div>
                  </div>
                  <span
                    className="invalid-select"
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                      margin: "0 110px",
                      color: "red",
                    }}
                  >
                    {rowItem.observaciones}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={`exampleModal${rowItem.id}`}
        tabIndex="-1"
        aria-labelledby={"archivo-" + rowItem.nombreArchivo}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id={"archivo-" + rowItem.nombreArchivo}
              >
                {rowItem.nombreArchivo}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ margin: "15px auto" }}>
              <img
                id={rowItem.nombreArchivo}
                src={rowItem.imageByteArray}
                alt={rowItem.nombreArchivo}
                style={{ height: "100%", width: "100%", objectFit: "contain" }}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
